import {gql} from 'apollo-boost'

export const qUrlProNahraniSouboru = gql`
  query UrlProNahraniSouboru($nazev: String!) {
    urlProNahraniSouboru(nazev: $nazev)
  }
`;
